import { apiAuth } from "./conection";

export const AddressesService = {
  getAddresses: async () => {
    const response = await apiAuth.get("/addresses/");
    return response.data;
  },
  createAddress: async (data) => {
    const response = await apiAuth.post("/addresses/", data);
    return response.data;
  },
  updateAddress: async ({ id, data }) => {
    const response = await apiAuth.put(`/addresses/${id}`, data);
    return response.data;
  },
  deleteAddress: async (id) => {
    const response = await apiAuth.delete(`/addresses/${id}`);
    return response.data;
  },
};
